import { useRef } from 'react'
import { classNames } from '@/util/tailwindHelpers'
import { Asset } from '@/api/resources/asset/get/schema'
import { MEDIA_SIZE, MEDIA_SIZES } from '@/constants'

interface RedeemableItemMediaProps
  extends React.ComponentPropsWithoutRef<'div'> {
  quality?: {
    token: keyof typeof MEDIA_SIZES
    box: keyof typeof MEDIA_SIZES
  }
  tokenClassName?: string
  onMediaLoaded?: () => void
  media: Asset['media']
}

const RedeemableMedia = ({
  media,
  quality = {
    token: MEDIA_SIZE.small,
    box: MEDIA_SIZE.default
  },
  className,
  tokenClassName,
  onMediaLoaded,
  ...rest
}: RedeemableItemMediaProps) => {
  const loadedItems = useRef<number>(0)

  const handleOnLoad = () => {
    loadedItems.current += 1
    if (loadedItems.current === media.length) {
      onMediaLoaded?.()
    }
  }

  const boxWidth = media[1][MEDIA_SIZES[quality.box].width]
  const boxHeight = media[1][MEDIA_SIZES[quality.box].height]

  return (
    <div
      style={{ '--aspect': `${boxWidth}/${boxHeight}` }}
      className={classNames(
        '@container-[size] relative w-full aspect-[--aspect] max-h-full',
        className
      )}
      {...rest}
    >
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        className="w-full h-full object-contain"
        src={media[1][MEDIA_SIZES[quality.box].url]}
        alt="redeemable"
        onLoad={handleOnLoad}
      />
      <div
        className={classNames(
          'absolute h-[50cqh] left-0 bottom-[-5cqh]  aspect-1',
          tokenClassName
        )}
      >
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          className="w-full h-full object-contain"
          src={media[0][MEDIA_SIZES[quality.token].url]}
          alt="redeemable"
          onLoad={handleOnLoad}
        />
      </div>
    </div>
  )
}

export default RedeemableMedia
